import Component from 'components/pages/AccountBalance/AccountBalance';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Account balance',
    description: 'View and access your account balance',
  },
});
